import { c as _c } from "react/compiler-runtime";
import type { LightGalleryCoreStrings } from 'lightgallery/lg-settings';
import type { LightGalleryProps } from 'lightgallery/react';
// eslint-disable-next-line no-restricted-imports
import { default as LightGalleryComponent } from 'lightgallery/react';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import './node_modules/LightGallery.scss';
const translations: LightGalleryCoreStrings = {
  closeGallery: 'Gallerie schließen',
  toggleMaximize: 'Vollbildmodus wechseln',
  nextSlide: 'Nächstes Bild',
  previousSlide: 'Vorheriges Bild',
  download: 'Download',
  playVideo: 'Video abspielen',
  mediaLoadingFailed: 'Es ist ein Fehler aufgetreten'
};
export function LightGallery(props) {
  const $ = _c(3);
  const {
    keys
  } = useEnvironment();
  let t0;
  if ($[0] !== keys.LIGHTGALLERY_LICENSE_KEY || $[1] !== props) {
    t0 = <LightGalleryComponent {...props} licenseKey={keys.LIGHTGALLERY_LICENSE_KEY} supportLegacyBrowser={false} strings={translations} />;
    $[0] = keys.LIGHTGALLERY_LICENSE_KEY;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}